import { useContext, useEffect, useState } from "react";
import { EventContext, EventContextType } from "../provider/EventProvider";
import GroupedEvents from "./GroupedEvents";
import { filterOnlyUnique } from "../../Helpers/utils";

export type EventListModel = {
  defaultImage: string
}

export default function EventList({ defaultImage }: EventListModel) {
  const [groups, setGroups] = useState<string[]>([]);

  const { events } = useContext(EventContext) as EventContextType;

  useEffect(() => {
    if (events) {
      const groupNames = events.map(x => x.groupName);
      setGroups(groupNames.length ? groupNames.filter(filterOnlyUnique) : []);
    }
  }, [events])

  return (
    <>
        { groups.length > 0 && groups.map((group, index) => {
            const nodes = events.filter(x => x.groupName === group).map(x => x.event);
            return (
              <div key={`event-group-${index}`} className="event-group">
                <h3>{group}</h3>
                <GroupedEvents nodes={nodes} defaultImage={defaultImage} />
              </div>
            )
          })
        }
    </>
  )
}